import React, { useEffect, useRef, useState } from 'react';
import './OTPVerify.css';

const OtpInput = ({ onComplete,onChange}) => {
  const length = 4;
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputs = useRef([]);

  const handleChange = (val, idx) => {
    if (!/^[0-9]?$/.test(val)) return;
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);

    const joinedOtp = newOtp.join('');
    onChange?.(joinedOtp); // <- Notify parent on every change
    
    if (val && idx < length - 1) inputs.current[idx + 1].focus();
    if (newOtp.join('').length === length) onComplete?.(newOtp.join(''));
  };

  const handleBackspace = (e, idx) => {
    if (e.key === 'Backspace' && !otp[idx] && idx > 0) {
      inputs.current[idx - 1].focus();
    }
  };


  return (
    <div className="otp-container">
      {otp.map((digit, i) => (
        <input
          key={i}
          ref={(el) => (inputs.current[i] = el)}
          className="otp-box"
          type="number"
          autofocus
          maxLength="1"
          value={digit}
          onChange={(e) => handleChange(e.target.value, i)}
          onKeyDown={(e) => handleBackspace(e, i)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
